module.exports = __webpack_public_path__ + "img/Background.4cc3a645.png";